import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useSiteStatusStore } from '@/stores';
import routerGuard from './routerGuard';
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Layout',
        redirect: '',
        component: () => import('@/layout/AppLayout.vue'),
        children: [
            {
                path: '',
                name: 'Home',
                component: () => import('@/pages/AppHome.vue')
            },
            {
                path: '/favorites',
                name: 'Favorites',
                component: () => import('@/pages/AppFavourite.vue'),
                meta: {
                    isNeedAuth: true
                }
            },
            {
                path: '/bonuses',
                name: 'Bonuses',
                component: () => import('@/components/PublicEngagements/PublicBonuses/PublicPage/PublicBonuses.vue'),
                meta: {
                    onlyNotAuth: true
                }
            },
            {
                path: '/levels',
                name: 'Levels',
                component: () => import('@/components/PublicEngagements/PublicLevels/PublicPage.vue'),
                meta: {
                    onlyNotAuth: true
                }
            },
            {
                path: '/cashback',
                name: 'Cashback',
                component: () => import('@/components/PublicEngagements/PublicCashback/PublicPage.vue')
                // meta: {
                //     onlyNotAuth: true
                // }
            },
            {
                path: '/terms',
                name: 'Terms',
                component: () => import('@/pages/Informations/AppTerms.vue')
            },
            {
                path: '/section/:type/:info',
                name: 'Section',
                component: () => import('@/pages/AppSection.vue'),
                props: true
            },
            {
                path: '/tournament/:id',
                name: 'tournament',
                redirect: (to) => `/tournament/${to.params.id}/info`,
                component: () => import('@/pages/AppTournament.vue'),
                props: true,
                children: [
                    {
                        path: 'info',
                        name: 'tournament_info',
                        component: () => import('@/components/PlayerProfile/Promotions/Tournaments/Page/Tabs/TournamentInfoTab.vue')
                    },
                    {
                        path: 'leaderboard',
                        name: 'tournament_leaderboard',
                        component: () => import('@/components/PlayerProfile/Promotions/Tournaments/Page/Tabs/Leaderboard/TournamentLeaderboardTab.vue')
                    },
                    {
                        path: 'available',
                        name: 'tournament_available',
                        component: () => import('@/components/PlayerProfile/Promotions/Tournaments/Page/Tabs/Availables/TournamentAvailableTab.vue')
                    }
                ]
            },
            {
                path: '/game/:game_string_id/:demo?',
                name: 'Game',
                component: () => import('@/pages/AppGame.vue'),
                props: true,
                meta: {
                    isNeedAuth: true
                }
            },
            {
                path: '/cashbox',
                name: 'Cashbox',
                component: () => import('@/pages/AppCashbox.vue'),
                redirect: '/cashbox/deposit',
                meta: {
                    isNeedAuth: true
                },
                children: [
                    {
                        path: 'deposit',
                        name: 'Deposit',
                        component: () => import('@/components/Cashbox/Deposit/DepositPage.vue')
                    },
                    {
                        path: 'cashout',
                        name: 'Cashout',
                        component: () => import('@/components/Cashbox/Cashout/CashoutPage.vue')
                    }
                ]
            },
            {
                path: '/profile',
                redirect: '/profile/general/me',
                name: 'Profile',
                component: () => import('@/pages/AppProfile.vue'),
                meta: {
                    isNeedAuth: true
                },
                children: [
                    {
                        path: 'general',
                        redirect: '/profile/general/me',
                        name: 'profile_general',
                        component: () => import('@/components/PlayerProfile/General/ProfileGeneral.vue'),
                        children: [
                            {
                                path: 'me',
                                name: 'profile_general_me',
                                component: () => import('@/components/PlayerProfile/General/Me/GeneralMe.vue')
                            },
                            {
                                path: 'verification',
                                name: 'profile_general_verification',
                                component: () => import('@/components/PlayerProfile/General/Verification/PlayerVerification.vue')
                            },
                            {
                                path: 'security',
                                name: 'profile_general_security',
                                component: () => import('@/components/PlayerProfile/General/Security/PlayerSecurity.vue')
                            },
                            {
                                path: 'notifications',
                                name: 'profile_general_notifications',
                                component: () => import('@/components/PlayerProfile/General/Notifications/PlayerNotifications.vue')
                            },
                            {
                                path: 'preferences',
                                name: 'profile_general_preferences',
                                component: () => import('@/components/PlayerProfile/General/Preferences/PlayerPreferences.vue')
                            },
                            {
                                path: 'limits',
                                name: 'profile_general_limits',
                                component: () => import('@/components/PlayerProfile/General/Limits/PlayerLimits.vue')
                            }
                        ]
                    },
                    // {
                    //     path: 'cashbox',
                    //     name: 'profile_cashbox',
                    //     redirect: '/profile/cashbox/history',
                    //     component: () => import('@/components/PlayerProfile/Cashbox/ProfileCashbox.vue'),
                    //     children: [
                    //         {
                    //             path: 'deposit',
                    //             name: 'profile_cashbox_deposit',
                    //             component: () => import('@/components/PlayerProfile/Cashbox/Deposit/CashboxDeposit.vue')
                    //         },
                    //         {
                    //             path: 'cashout',
                    //             name: 'profile_cashbox_cashout',
                    //             component: () => import('@/components/PlayerProfile/Cashbox/Cashout/CashboxCashout.vue')
                    //         }
                    //     ]
                    // },
                    {
                        path: 'history',
                        name: 'profile_history',
                        redirect: '/profile/history/payments',
                        component: () => import('@/components/PlayerProfile/History/ProfileHistory.vue'),
                        children: [
                            {
                                path: 'payments',
                                name: 'profile_history_payments',
                                component: () => import('@/components/PlayerProfile/History/Payments/PaymentsHistory.vue')
                            },
                            {
                                path: 'tournaments',
                                name: 'profile_history_tournaments',
                                component: () => import('@/components/PlayerProfile/History/Tournaments/TournamentsHistory.vue')
                            },
                            {
                                path: 'compensations',
                                name: 'profile_history_compensations',
                                component: () => import('@/components/PlayerProfile/History/Compensations/CompensationsHistory.vue')
                            },
                            {
                                path: 'cashbacks',
                                name: 'profile_history_cashbacks',
                                component: () => import('@/components/PlayerProfile/History/Cashbacks/CashbackHistory.vue')
                            }
                        ]
                    },
                    {
                        path: 'promotions',
                        name: 'profile_promotions',
                        redirect: '/profile/promotions/levels',
                        component: () => import('@/components/PlayerProfile/Promotions/ProfilePromotions.vue'),
                        children: [
                            {
                                path: 'levels',
                                name: 'profile_promotions_levels',
                                component: () => import('@/components/PlayerProfile/Promotions/Levels/PlayerLevels.vue')
                            },
                            {
                                path: 'bonuses',
                                name: 'profile_promotions_bonuses',
                                redirect: '/profile/promotions/bonuses/my',
                                component: () => import('@/components/PlayerProfile/Promotions/Bonuses/PlayerBonuses.vue'),
                                children: [
                                    {
                                        path: 'my',
                                        name: 'profile_promotions_bonuses_my',
                                        component: () => import('@/components/PlayerProfile/Promotions/Bonuses/BonusSections/My/MyBonuses.vue')
                                    },
                                    {
                                        path: 'available',
                                        name: 'profile_promotions_bonuses_available',
                                        component: () => import('@/components/PlayerProfile/Promotions/Bonuses/BonusSections/Available/AvailableBonuses.vue')
                                    }
                                ]
                            },
                            {
                                path: 'tournaments',
                                redirect: '/profile/promotions/tournaments/my',
                                name: 'profile_promotions_tournaments',
                                component: () => import('@/components/PlayerProfile/Promotions/Tournaments/Card/PlayerTournaments.vue'),
                                children: [
                                    {
                                        path: 'my',
                                        name: 'profile_promotions_tournaments_my',
                                        component: () => import('@/components/PlayerProfile/Promotions/Tournaments/Card/TournamentSections/My/MyTournaments.vue')
                                    },
                                    {
                                        path: 'available',
                                        name: 'profile_promotions_tournaments_available',
                                        component: () => import('@/components/PlayerProfile/Promotions/Tournaments/Card/TournamentSections/Available/AvailableTournaments.vue')
                                    }
                                ]
                            },
                            {
                                path: 'wheel',
                                name: 'profile_promotions_wheel',
                                component: () => import('@/components/PlayerProfile/Promotions/Wheel/PlayerWheel.vue')
                            },
                            {
                                path: 'cashback',
                                name: 'profile_promotions_cashback',
                                component: () => import('@/components/PlayerProfile/Promotions/Cashback/PlayerCashback.vue')
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: '/auth',
        name: 'Auth',
        component: () => import('@/pages/AppAuth.vue'),
        meta: {
            onlyNotAuth: true
        },
        redirect: '/auth/login',
        children: [
            {
                path: 'signup',
                name: 'Signup',
                component: () => import('@/components/Auth/Signup/TheSignup.vue')
            },
            {
                path: 'login',
                name: 'Login',
                component: () => import('@/components/Auth/Signin/TheSignin.vue')
            }
        ]
    },
    {
        path: '/maintenance',
        name: 'Maintenance',
        component: () => import('@/pages/AppMaintenance.vue'),
        beforeEnter: (to, from, next) => {
            const statusStore = useSiteStatusStore();
            if (!statusStore.isMaintenance) {
                next('/');
            } else {
                next();
            }
        }
    },
    {
        path: '/blocked',
        name: 'Blocked',
        component: () => import('@/pages/AppRegionBlock.vue'),
        beforeEnter: (to, from, next) => {
            const statusStore = useSiteStatusStore();
            if (!statusStore.isBlocked) {
                next('/');
            } else {
                next();
            }
        }
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/'
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    // scrollBehavior(to, from, savedPosition) {
    //     if (savedPosition) {
    //         return savedPosition;
    //     } else if (to.name !== 'Home') {
    //         return { top: 0 };
    //     }
    // }
    // scrollBehavior(to, from, savedPosition) {
    //     // console.log(to, from, savedPosition);
    //     if (savedPosition) {
    //         return {
    //             ...savedPosition,
    //             behavior: 'smooth'
    //         };
    //     }

    //     return {
    //         top: 0,
    //         behavior: 'instant'
    //     };
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve) => {
            setTimeout(() => {
                if (savedPosition) {
                    resolve({ ...savedPosition, behavior: 'instant' });
                } else if (to.name !== 'Home') {
                    resolve({ top: 0, behavior: 'instant' });
                }
            }, 0);
        });
    }
});
routerGuard(router);
export default router;
